const experiences = [
  {
    title: "Développeur Web Full-Stack",
    complement: "en alternance",
    entreprise: "Yoozly",
    date: "2023 - 2025",
    description:
      "Développement et maintenance d'applications web et mobiles. Résolution de tickets de TMA, création d'applications mobiles Angular/Ionic, développement de sites WordPress, et applications Angular. Participation à l'amélioration des processus de développement.",
    technologies: ["Angular", "Ionic", "WordPress", "PHP", "TypeScript"],
    lieu: "Lille",
  },
  {
    title: "Développeur Web Full-Stack",
    complement: "en alternance",
    entreprise: "Feel Agile",
    date: "2022 - 2023",
    description:
      "Conception et développement d'une application SaaS de gouvernance, risques et conformité informatique. Développement front-end avec React/TypeScript et back-end avec Laravel. Collaboration en équipe agile.",
    technologies: ["React", "TypeScript", "Laravel", "PostgreSQL"],
    lieu: "Rouen",
  },
  {
    title: "Serveur lors d'extras",
    entreprise: "Délice du Soleil / Cirette Traiteur",
    date: "2017 - 2023",
    description:
      "Service et préparation culinaire lors d'événements privés et professionnels (mariages, séminaires, réceptions). Gestion de la relation client et travail en équipe sous pression.",
    technologies: [],
    lieu: "Rouen",
  },
  {
    title: "Animateur colonie de vacances",
    entreprise: "Planètes Vacances",
    date: "2017 - 2021",
    description:
      "Encadrement et animation d'activités pour enfants et adolescents de 12 à 17 ans. Organisation de séjours de vacances, gestion de groupes, et garantie de la sécurité des participants.",
    technologies: [],
    lieu: "France",
  },
];

export default experiences;
